import { WguEventBus } from '@/WguEventBus'

export default {
  data () {
    return {
      _unifiedMapMountedHandler: null,
      _unifiedMapResizeObserver: null,
      _unifiedMapResizeRaf: null,
      _unifiedMapWindowResizeHandler: null
    }
  },
  beforeDestroy () {
    this.stopUnifiedMapLifecycle()
  },
  methods: {
    startUnifiedMapLifecycle (options = {}) {
      const {
        containerRef = 'mapContainer',
        onMapReady = null,
        extraDelays = [200, 800]
      } = options

      const applyMap = (map) => {
        if (!map) return
        if (Object.prototype.hasOwnProperty.call(this, 'mapRef')) {
          this.mapRef = map
        }
        if (typeof onMapReady === 'function') {
          onMapReady(map)
        }
        this.scheduleUnifiedMapResize(map)
        extraDelays.forEach(delay => {
          setTimeout(() => this.scheduleUnifiedMapResize(map), delay)
        })
      }

      this._unifiedMapMountedHandler = (map) => {
        applyMap(map)
      }
      WguEventBus.$on('ol-map-mounted', this._unifiedMapMountedHandler)

      this.$nextTick(() => {
        const container = this.$refs?.[containerRef]
        this.setupUnifiedMapResizeSync(container)

        if (this.$map) {
          applyMap(this.$map)
        } else {
          this.scheduleUnifiedMapResize()
        }
      })
    },

    setupUnifiedMapResizeSync (container) {
      if (container && window.ResizeObserver) {
        this._unifiedMapResizeObserver = new window.ResizeObserver(() => {
          this.scheduleUnifiedMapResize()
        })
        this._unifiedMapResizeObserver.observe(container)
      }

      this._unifiedMapWindowResizeHandler = () => {
        this.scheduleUnifiedMapResize()
      }
      window.addEventListener('resize', this._unifiedMapWindowResizeHandler)
    },

    scheduleUnifiedMapResize (mapArg = null) {
      if (this._unifiedMapResizeRaf) {
        cancelAnimationFrame(this._unifiedMapResizeRaf)
      }

      this._unifiedMapResizeRaf = requestAnimationFrame(() => {
        this._unifiedMapResizeRaf = null
        const map = mapArg || this.mapRef || this.$map
        if (!map || typeof map.updateSize !== 'function') return

        map.updateSize()
        if (typeof map.render === 'function') {
          map.render()
        }
      })
    },

    stopUnifiedMapLifecycle () {
      if (this._unifiedMapMountedHandler) {
        WguEventBus.$off('ol-map-mounted', this._unifiedMapMountedHandler)
        this._unifiedMapMountedHandler = null
      }

      if (this._unifiedMapResizeObserver) {
        this._unifiedMapResizeObserver.disconnect()
        this._unifiedMapResizeObserver = null
      }

      if (this._unifiedMapResizeRaf) {
        cancelAnimationFrame(this._unifiedMapResizeRaf)
        this._unifiedMapResizeRaf = null
      }

      if (this._unifiedMapWindowResizeHandler) {
        window.removeEventListener('resize', this._unifiedMapWindowResizeHandler)
        this._unifiedMapWindowResizeHandler = null
      }
    }
  }
}
